import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcWarning = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.9998 2.29175C6.19036 2.29175 2.2915 6.1906 2.2915 11.0001C2.2915 15.8096 6.19036 19.7084 10.9998 19.7084C15.8093 19.7084 19.7082 15.8096 19.7082 11.0001C19.7082 6.1906 15.8093 2.29175 10.9998 2.29175ZM10.2059 11.3056C10.2059 11.8119 10.6163 12.2223 11.1225 12.2223C11.6288 12.2223 12.0392 11.8119 12.0392 11.3056V7.39453C12.0392 6.88827 11.6288 6.47786 11.1225 6.47786C10.6163 6.47786 10.2059 6.88827 10.2059 7.39453L10.2059 11.3056ZM11.0612 13.2611C10.3524 13.2611 9.77785 13.8357 9.77785 14.5445C9.77785 15.2532 10.3524 15.8278 11.0612 15.8278C11.7699 15.8278 12.3445 15.2532 12.3445 14.5445C12.3445 13.8357 11.7699 13.2611 11.0612 13.2611Z",
		fill: "currentColor"
	})
});
export default SvgIcWarning;
